import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import App from './App';
import {GlobalProvider} from './contexts/GlobalContext';
import { i18nPronto } from './i18n';
// Sincroniza o locale das libs de data com o idioma ativo (efeito de import).
import './i18n/dateLocale';
// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

Sentry.init({
    dsn: "https://40a5b7fed8c37d3c843af024a41a372f@o4507624473559040.ingest.us.sentry.io/4507624478670848",
    integrations: [],
});

window.addEventListener('error', (event) => {
    try {
        const debug = {
            ts: new Date().toISOString(),
            type: 'window.error',
            message: event?.message,
            filename: event?.filename,
            lineno: event?.lineno,
            colno: event?.colno,
            stack: event?.error?.stack,
            url: window.location.href,
        };
        console.error('[global][window.error]', debug);
        window.__lastGlobalError = debug;
        try { sessionStorage.setItem('lastGlobalError', JSON.stringify(debug)); } catch (_) { /* ignore */ }
    } catch (_) { /* ignore */ }
});

window.addEventListener('unhandledrejection', (event) => {
    try {
        const reason = event?.reason;
        const debug = {
            ts: new Date().toISOString(),
            type: 'unhandledrejection',
            message: reason?.message || String(reason),
            stack: reason?.stack,
            url: window.location.href,
        };
        console.error('[global][unhandledrejection]', debug);
        window.__lastGlobalError = debug;
        try { sessionStorage.setItem('lastGlobalError', JSON.stringify(debug)); } catch (_) { /* ignore */ }
    } catch (_) { /* ignore */ }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderizarApp = () => {
    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <GlobalProvider>
                    <App />
                </GlobalProvider>
            </BrowserRouter>
        </React.StrictMode>
    );
};

// Enquanto as traduções do idioma carregam (em rede lenta pode demorar), a página
// mostra um carregando em vez de ficar em branco. Sem texto: ainda não há tradução.
root.render(
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }} aria-busy="true">
        <div className="spinner-border text-secondary" role="status" />
    </div>
);

// Aguarda o carregamento das traduções do idioma antes da primeira pintura. Sem
// isso a tela apareceria por um instante com as chaves de tradução no lugar dos
// textos, já que o i18next está configurado sem Suspense (ver src/i18n/index.js).
i18nPronto
    .then(renderizarApp)
    .catch((erro) => {
        // Falha ao carregar traduções não pode impedir o app de subir: o i18next
        // cai no fallback e a interface renderiza em português.
        console.error('[i18n] Falha ao inicializar as traduções:', erro);
        renderizarApp();
    });
